import { useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Languages from './components/Languages';
import Training from './components/Training';
import Internship from './components/Internship';

export default function Home() {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section[id]');
      const scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = (current as HTMLElement).offsetHeight;
        const sectionTop = (current as HTMLElement).offsetTop - 100;
        const sectionId = current.getAttribute('id');

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          document.querySelector(`.nav__link[href*=${sectionId}]`)?.classList.add('active');
        } else {
          document.querySelector(`.nav__link[href*=${sectionId}]`)?.classList.remove('active');
        }
      });

      const scrollUpButton = document.getElementById('scroll-up');
      if (scrollUpButton) {
        if (window.scrollY >= 560) {
          scrollUpButton.classList.add('show-scroll');
        } else {
          scrollUpButton.classList.remove('show-scroll');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <Skills />
      <Languages />
      <Training />
      <Internship />
      
      <button
        id="scroll-up"
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-blue-600 text-white rounded-lg shadow-lg items-center justify-center opacity-0 invisible transition-all duration-300 hover:bg-blue-700 hover:scale-110 active:scale-95 cursor-pointer z-50"
        style={{ display: 'flex' }}
      >
        <i className="ri-arrow-up-line text-2xl transition-transform duration-300 hover:translate-y-[-2px]"></i>
      </button>

      <style>{`
        .show-scroll {
          opacity: 1 !important;
          visibility: visible !important;
        }
        
        #scroll-up:active i {
          transform: translateY(-4px);
        }
      `}</style>
    </div>
  );
}
